import React from 'react'
import { X, Play } from 'lucide-react'

export interface VideoPlayerModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  videoUrl?: string
}

export function VideoPlayerModal({
  isOpen,
  onClose,
  title = 'Understanding Cash Margin & RetailORBIT Health Score',
  videoUrl = 'https://www.youtube.com/embed/h2x3__fx15E?autoplay=1',
}: VideoPlayerModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-4 transition-opacity animate-in fade-in duration-200">
      <div
        className="fixed inset-0"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="relative z-10 flex w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl border border-slate-200 animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-purple-100 text-purple-700">
              <Play className="h-4 w-4 fill-purple-700 ml-0.5" />
            </div>
            <h3 className="text-base font-bold text-slate-900">{title}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Video Player */}
        <div className="relative aspect-video w-full bg-black">
          <iframe
            src={videoUrl}
            title={title}
            className="h-full w-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between bg-slate-50 px-5 py-3.5 border-t border-slate-100 text-xs text-slate-500">
          <span>Learn how to optimize your cash flow, open-to-buy budgets, and gross margins.</span>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-slate-300 bg-white px-3 py-1 font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
